import { createSseStream } from "./sseClient";
import { sseSubscriptionRegistry } from "./sseSubscriptionRegistry";
import { buildSseKey } from "./sseContract";

/**
 * Subscribes to SSE updates for a project or collection record.
 */
export function subscribeToRecordUpdates({
  resourceType,
  subject,
  userId,
  getToken,
  onUpdated,
  onStatus,
  onError,
}) {
  const key = buildSseKey({
    resourceType,
    subject,
    userId,
  });

  return sseSubscriptionRegistry.subscribe(
    key,
    (emit) =>
      createSseStream({
        userId,
        subject,
        getToken,
        onPayload: emit,
        onStatus,
        onError,
      }),
    onUpdated
  );
}
